import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from 'utils/axios'

export const fetchTaskGroups = (teamUuid, params = {}) => {
  const url = `/v2/teams/${teamUuid}/task-groups`

  return getRequest(url, params)
}

export const fetchTaskGroup = (taskGroupUuid) => {
  const url = `/v2/task-groups/${taskGroupUuid}`

  return getRequest(url)
}

export const fetchTaskGroupTasks = (taskGroupUuid) => {
  const url = `/v2/task-groups/${taskGroupUuid}/tasks`

  return getRequest(url)
}

export const createTaskGroup = (teamUuid, data) => {
  const url = `/v2/teams/${teamUuid}/task-groups`

  return postRequest(url, data)
}

export const updateTaskGroup = (taskGroupUuid, data) => {
  const url = `/v2/task-groups/${taskGroupUuid}`

  return patchRequest(url, data)
}

export const deleteTaskGroup = (taskGroupUuid) => {
  const url = `/v2/task-groups/${taskGroupUuid}`

  return deleteRequest(url)
}
